import NewTripOrder from "../../../../components/@documents/trip_orders/NewTripOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TripOrderNewPage() {

    return (
        <NewTripOrder 
            routeType={routeTypes.workstation}
        />
    )
}